const CustomMapMarkerIcon = ({color}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16.494" height="23.757" viewBox="0 0 16.494 23.757">
            <defs>
                {/*<clipPath id="clip-path">*/}
                    {/*<rect id="Rectangle_1693" data-name="Rectangle 1693" width="16.494" height="23.757" fill="none"/>*/}
                {/*</clipPath>*/}
            </defs>
            <g id="Group_386" data-name="Group 386" transform="translate(0 0)">
                <g id="Group_386-2" data-name="Group 386" transform="translate(0 0)" clipPath="url(#clip-path)">
                    <ellipse id="Ellipse_102" data-name="Ellipse 102" cx="5.675" cy="2.417" rx="5.675" ry="2.417" transform="translate(2.446 18.52)" fill="none" stroke={color} strokeMiterlimit="10" strokeWidth="0.906"/>
                    <path id="Path_776" data-name="Path 776" d="M8.247,0A8.247,8.247,0,0,0,0,8.247C0,12.8,8.247,21.174,8.247,21.174S16.494,12.8,16.494,8.247A8.247,8.247,0,0,0,8.247,0M7.266,13.05l-.017-.007-2.227,1.91-.069-2.937-.017-.008L8.552,3.921l2.33,1.042ZM11.5,3.58l-.449,1L8.721,3.542l.449-1a.692.692,0,0,1,.913-.35l1.067.477a.691.691,0,0,1,.349.913" transform="translate(0 0)" fill={color}/>
                </g>
            </g>
        </svg>
    )
}

export default CustomMapMarkerIcon
